/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_All_HelpInputs */



/**
* | output |
* | --- |
* | "Auto format all events in the selected event group." |
*
* @param {Apply_To_All_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all_help = /** @type {((inputs?: Apply_To_All_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_All_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Auto-formater tous les événements du groupe sélectionné.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Ereignisse in der ausgewählten Ereignisgruppe automatisch formatieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formatta automaticamente tutti gli eventi nel gruppo di eventi selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование всех событий в выбранной группе событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatear automáticamente todos los eventos en el grupo de eventos seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化所选事件组中的所有事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベント グループ内のすべてのイベントを自動フォーマットします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह में सभी इवेंट्स को स्वचालित रूप से फॉर्मेट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatar automaticamente todos os eventos no grupo de eventos selecionado.")
	return /** @type {LocalizedString} */ ("Auto format all events in the selected event group.")
});